import { OktaAuth } from '@okta/okta-auth-js';
import { envs } from './config';

const oktaAuthService = new OktaAuth({
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  issuer: envs.REACT_APP_OKTA_ISSUER!,
  clientId: envs.REACT_APP_OKTA_CLIENT_ID,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['user', 'openid', 'email', 'profile'],
});

export default oktaAuthService;
